import { Avatar } from "@mui/material";
import { useContext } from "react";
import { PaycheckContext } from "../../../../contexts";
import { ProfileHeaderProps } from "../../../../types/components/profileHeader.types";

import "./header.css";

const Header = ({ first_name, last_name, group_name }: ProfileHeaderProps): JSX.Element => {
	const { paycheck } = useContext(PaycheckContext);

	return (
		<div className="profile-header">
			<div className="name">
				{first_name} {last_name}
			</div>
			<div className="avatar-meta-cont">
				<Avatar className="avatar">{first_name[0] + last_name[0]}</Avatar>
				<div className="assign-info">
					<div className="group-name">{group_name}</div>
					<div className="location-name">{paycheck?.location_name}</div>
				</div>
			</div>
		</div>
	);
};

export default Header;
